<template>
  <div class="fundPrices">
    <v-row>
      <v-col cols="12" sm="6" class="pa-3">
        <h2>Investment Prices</h2>
        <div class="areaTitle">
          <v-select
            v-model="currentManager"
            :style="{ 'max-width': '250px' }"
            :items="managerList"
            item-value="ManagerId"
            item-text="ManagerName"
            label="Manager"
            hide-details="true"
            return-object
            outlined
            dense
            @change="onManagerChange()"
          >
          </v-select>

          <v-select
            v-if="currentManager && currentManager.ManagerId"
            v-model="currentFund"
            :style="{ 'max-width': '250px' }"
            :items="fundList"
            item-value="PortfolioId"
            item-text="PortfolioName"
            label="Fund"
            hide-details="true"
            return-object
            outlined
            dense
            @change="onFundChange()"
          >
          </v-select>

          <v-btn
            color="primary"
            depressed
            :disabled="!showFormButtons || !isManagerAndFundSelected"
            @click="onButtonClicked('add')"
            class="ml-2"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add new price
          </v-btn>
        </div>
        <v-card class="pa-2" outlined tile>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="priceList"
            :items-per-page="-1"
            item-key="PriceId"
            dense
            single-select
            @click:row="selectPrice"
          >
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6" class="pa-3">
        <v-alert v-if="!isEditMode && !isManagerAndFundSelected" outlined dense type="info">
          Please select a manager and a fund.
        </v-alert>
        <div v-else style="padding: 20px" class="formContainer">
          <DatePicker
            label="Price Date"
            v-model="currentPrice._PriceDate"
            :rules="[(v) => !!v || 'Required']"
            :readonly="readOnly"
          ></DatePicker>
          <v-select
            :items="priceTypes"
            item-value="value"
            item-text="text"
            label="Price Type"
            v-model="currentPrice._PriceType"
            :rules="[(v) => !!v || 'Required']"
            :readonly="readOnly"
          ></v-select>
          <v-text-field
            label="Bid Price"
            type="number"
            v-model="currentPrice._BidPrice"
            :rules="[(v) => !!v || 'Required']"
            :readonly="readOnly"
          ></v-text-field>
          <v-text-field
            label="Offer Price"
            type="number"
            v-model="currentPrice._OfferPrice"
            :rules="[(v) => !!v || 'Required']"
            :readonly="readOnly"
          ></v-text-field>
          <div v-if="showFormButtons" class="formFooter">
            <div class="btnContainer">
              <v-btn
                v-if="!isEditMode && isManagerAndFundSelected"
                outlined
                color="error"
                @click="onButtonClicked('delete')"
                >Delete</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn v-if="!isEditMode" outlined color="primary" @click="onButtonClicked('edit')">
                Edit
              </v-btn>
              <v-btn v-if="isEditMode" outlined color="primary" @click="onButtonClicked('cancel')">
                Cancel
              </v-btn>
              <v-btn
                v-if="isEditMode"
                depressed
                color="primary"
                @click="onButtonClicked('save')"
                class="ml-4"
              >
                Save
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <Dialog ref="messageBox"></Dialog>
  </div>
</template>
<script>
import Dialog from '@/components/layout/Dialog.vue';
import DatePicker from '@/components/formControls/DatePicker.vue';

export default {
  name: 'FundPrices',
  components: {
    Dialog,
    DatePicker,
  },
  data() {
    return {
      message: 'Are you sure you wish to delete this record ?',
      title: 'Confirmation',
      readOnly: true,
      isEditMode: false,
      dialog: false,
      selected: [],
      isMemberForm: false,
      updateMode: 'Update',
      fundId: 0,
      currentPrice: {},
      previousPrice: {},
      priceTypes: [
        { value: 'F', text: 'Final' },
        { value: 'P', text: 'Provisional' },
      ],
      priceList: [],
      count: 0,
      headers: [
        { text: 'Price Date', value: '_PriceDate' },
        { text: 'Type', value: '_PriceType' },
        { text: 'Bid Price', value: '_BidPrice' },
        { text: 'Offer Price', value: '_OfferPrice' },
      ],
      currentManager: {},
      managerList: [],
      currentFund: {},
      fundList: [],
    };
  },
  computed: {
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },

    isManagerAndFundSelected() {
      return Object.keys(this.currentManager).length && Object.keys(this.currentFund).length;
    },
  },

  watch: {
    fundId() {
      if (this.fundId > 0){
        this.getFundPriceList();
      }
      
    },
  },

  methods: {
    onManagerChange() {
      this.currentFund = {};
      this.currentPrice = {};
      this.previousPrice = {};
      this.priceList = [];
      this.fundId = -1;
      if (this.currentManager && this.currentManager.ManagerId) {
        this.getFundList(this.currentManager.ManagerId);
      }
    },

    onFundChange() {
      this.fundId = -1;
      if (this.currentFund && this.currentFund.PortfolioId) {
        this.fundId = this.currentFund.PortfolioId;
      }
    },

    async getManagerList() {
      try {
        let response = await this.$api.get('/funds/getManagerList');
        var data = response.data;
        this.managerList = data;
      } catch (err) {
        console.error(err);
      }
    },

    async getFundList(managerId) {
      this.fundList = [];
      try {
        let response = await this.$api.get('/funds/getFundList', {
          params: { managerId: managerId },
        });
        var data = response.data;
        if (response.data) this.fundList = data;
      } catch (err) {
        console.error(err);
      }
    },

    async getFundAndManager() {
      try {
        let response = await this.$api.get('/funds/getFund', { params: { fundId: this.fundId } });

        if (!response.data) {
          const msg = 'Unable to load fund with id ' + this.fundId;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.currentFund = response.data;

        await this.getManagerList();

        this.currentManager = this.managerList.find(
          (x) => x.ManagerId == this.currentFund.ManagerId
        );

        this.getFundList(this.currentManager.ManagerId);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    selectPrice(item) {
      this.getPrice(this.fundId, item._PriceDate, item._PriceType);
      this.selected = [item];
      this.isEditMode = false;
      this.readOnly = true;
    },

    createNewPrice() {
      return {
        _PortfolioId: this.fundId,
        _PriceDate: '',
        _PriceType: '',
        _PricePerShare: 0.0,
        _BidPrice: 0.0,
        _OfferPrice: 0.0,
        _OldPriceType: null,
      };
    },

    async getPrice(fundId, priceDate, priceType) {
      try {
        let response = await this.$api.get('/funds/getfundpricebydate', {
          params: { fundId: fundId, priceDate: priceDate, priceType: priceType },
        });

        this.currentPrice = response.data;
        
      } catch (err) {
        console.error(err);
      }
    },
    async getFundPriceList() {
      try {
        let response = await this.$api.get('/funds/GetFundPrices?fundid=' + this.fundId);

        var data = response.data.map((item, index) => ({
          ...item,
          PriceId: index + 1,
        }));

        this.priceList = data;
        if (data.length > 0) {
          this.currentPrice = data[0];
          this.selected = [data[0]];
        } else {
          this.currentPrice = {};
          this.selected = [];
        }
      } catch (err) {
        console.error(err);
      }
    },
    async updatePrice() {
      try {
        this.currentPrice._OldPriceType = this.previousPrice._PriceType;
        await this.$api.post('/funds/updateFundPrice', this.currentPrice);
        this.readOnly = true;
        this.isEditMode = false;

        this.getFundPriceList();
      } catch (err) {
        console.error(err);
      }
    },
    async insertPrice() {
      try {
        await this.$api.post('/funds/insertFundPrice', this.currentPrice);
        this.readOnly = true;
        this.isEditMode = false;
        this.getFundPriceList();
      } catch (err) {
        console.error(err);
      }
    },

    async deletePrice() {
      try {
        await this.$api.post('/funds/deleteFundPrice', this.currentPrice);

        this.getFundPriceList();
      } catch (err) {
        console.error(err);
      }
    },

    async onButtonClicked(value) {
      if (value == 'cancel') {
        // reload data
        this.getPrice(this.fundId, this.previousPrice._PriceDate, this.previousPrice._PriceType);
        this.readOnly = true;
        this.isEditMode = false;
      } else if (value == 'add') {
        // clear data
        this.isEditMode = true;
        this.previousPrice = { ...this.currentPrice };
        this.currentPrice = this.createNewPrice();
        this.selected = [];
        this.readOnly = false;
        this.updateMode = 'Add';
      } else if (value == 'save') {
        this.readOnly = true;
        if (this.updateMode == 'Update') {
          this.updatePrice();
        } else {
          this.insertPrice();
        }
      } else if (value == 'edit') {
        this.previousPrice = { ...this.currentPrice };
        this.readOnly = false;
        this.isEditMode = true;
        this.updateMode = 'Update';
      } else if (value == 'delete') {
        if (
          await this.$refs.messageBox.open(
            'Confirmation',
            'Are you sure you wish to delete this record ?'
          )
        ) {
          this.deletePrice();
        }
      }
    },
  },

  mounted: function () {
    const queryParam = this.$route.query.fundid;
    if (queryParam && queryParam > 0) {
      this.fundId = queryParam;
      this.getFundAndManager();
    } else {
      this.getManagerList();
    }
  },
};
</script>

<style lang="scss" scoped>
.fundPrices {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;

  .formContainer {
    position: relative;
    height: 100%;

    .formFooter {
      bottom: 0;
      width: 100%;
      margin-top: 5px;

      position: sticky;
      background-color: white;
      padding: 8px 0 0 0;
      border-top: 1px solid rgba(0, 0, 0, 0.12);

      .btnContainer {
        display: flex;
      }
    }
  }

  .areaTitle {
    display: flex;
    gap: 5px;
    //justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    flex-wrap: wrap;
  }
}
</style>
